/**
 * Format challenge rating for display. Converts decimals to D&D 5e fractions.
 * Standard CRs: 0, 1/8 (0.125), 1/4 (0.25), 1/2 (0.5), then whole numbers 1–30.
 */
export function formatChallengeRating(cr: string | number | undefined | null): string {
  if (cr === undefined || cr === null) return '0';
  const crNum = typeof cr === 'string' ? parseFloat(cr) : Number(cr);
  if (Number.isNaN(crNum)) return '0';
  if (Number.isInteger(crNum)) return crNum.toString();

  // Standard D&D 5e CR fractions (exact matches)
  if (Math.abs(crNum - 0.125) < 0.001) return '1/8';
  if (Math.abs(crNum - 0.25) < 0.001) return '1/4';
  if (Math.abs(crNum - 0.5) < 0.001) return '1/2';

  // Round non-standard values to nearest standard CR
  const standardCRs = [0, 0.125, 0.25, 0.5, 1];
  let nearestCR = standardCRs[0];
  let minDiff = Math.abs(crNum - standardCRs[0]);

  for (const standardCR of standardCRs) {
    const diff = Math.abs(crNum - standardCR);
    if (diff < minDiff) {
      minDiff = diff;
      nearestCR = standardCR;
    }
  }

  if (minDiff < 0.1) {
    if (nearestCR === 0.125) return '1/8';
    if (nearestCR === 0.25) return '1/4';
    if (nearestCR === 0.5) return '1/2';
    if (nearestCR === 0) return '0';
    return nearestCR.toString();
  }

  const rounded = Math.round(crNum);
  return rounded.toString();
}
